/** Shared sigil set for geometry census (keeps inspect free of LSP deps). */
export const SIGIL_CHARS = ['^', '!', '?', '~', '*', '=', '@', '#', '.', '&', '$', '%'] as const
